<template>
  <el-dialog
    :title="editTitle"
    width="820px"
    @open="initData"
    :close-on-click-modal="false"
    :visible.sync="visible"
    :before-close="handleCancel">
    <div class="user-edit-container">
      <table class="check-item-table">
        <tr>
          <td colspan="3" class="check-subject-header">科目：<span class="subject-name">{{subjectName}}</span></td>
        </tr>
        <!-- <tr class="check-item-row">
          <td rowspan="5" class="check-label-wrapper"><span class="check-label">试评前检查项</span></td>
          <td><span>1. 导入考生</span></td>
          <td v-if="workItemStatus[0]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
          <td v-else>
             <span class="check-tip error-tip" v-if="typeof workItemStatus[0] !== 'undefined'">
              <i class="iconfont icon-jinggao-copy check-fail"></i>
              <span class="fail-label">到首页“待处理”把该工作项完成才能开启试评。</span>
            </span>
          </td>
        </tr> -->
        <tr class="check-item-row">
          <td><span>1. 收集题卡信息</span></td>
          <td v-if="workItemStatus[1]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
          <td v-else>
            <span class="check-tip error-tip" v-if="typeof workItemStatus[1] !== 'undefined'">
              <i class="iconfont icon-jinggao-copy check-fail"></i>
              <span class="fail-label">到首页“待处理”把该工作项完成才能开启试评。</span>
            </span>
          </td>
        </tr>
        <tr class="check-item-row">
          <td><span>2. 设评卷方案</span></td>
          <td v-if="workItemStatus[2]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
          <td v-else>
            <span class="check-tip error-tip" v-if="typeof workItemStatus[2] !== 'undefined'">
              <i class="iconfont icon-jinggao-copy check-fail"></i>
              <span class="fail-label">到首页“待处理”把该工作项完成才能开启试评。</span>
            </span>
          </td>
        </tr>
        <tr class="check-item-row">
          <td><span>3. 分评卷任务</span></td>
          <td v-if="workItemStatus[3]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
          <td v-else>
            <span class="check-tip warn-tip" v-if="typeof workItemStatus[3] !== 'undefined'">
              <i class="iconfont icon-jinggao-copy check-warn"></i>
              <span class="warn-label">未完成</span>
            </span>
          </td>
        </tr>
        <tr class="check-item-row">
          <td><span>4. 扫描上传答题卡数量</span></td>
          <td v-if="workItemStatus[4]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
          <td v-else>
            <span class="check-tip error-tip" v-if="typeof workItemStatus[4] !== 'undefined'">
              <i class="iconfont icon-jinggao-copy check-fail"></i>
              <span class="fail-label">上传答题卡数量为0（无卷可评）不能开启试评。请督促答题卡扫描上传工作。</span>
            </span>
          </td>
        </tr>
      </table>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="success" @click="handleNext" :loading="submitLoading">{{confirmLabel}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {queryExamMonitor} from '@/model/exam-manager-model'
import {assignPJVM} from '@/model/pj-server-model'
import {queryScanProgressSummary} from '@/model/monitor-scan-model'
import common from '@/util/common'

export default {
  name: 'OpenPreMark',
  props: {
    subjectId: {
      type: String,
      required: true
    },
    examId: {
      type: String,
      required: true
    },
    subjectName: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    userInfo () {
      return common.getUserInfo()
    }
  },
  data () {
    return {
      editTitle: '开启试评',
      // 确认按钮文本  '我知道了'、'去开启试评'
      confirmLabel: '我知道了',
      // 0:未完成，1：完成
      workItemStatus: [],
      // 题目列表
      // items: []
      items: [],
      submitLoading: false
    }
  },
  created () {
    this.initData()
  },
  methods: {
    handleNext () {
      switch (this.confirmLabel) {
        case '我知道了':
          this.$emit('dialog-close', {})
          break
        case '去开启试评':
          this.submitLoading = true
          let param = {examId: this.examId, subjectId: this.subjectId}
          assignPJVM(param).then((pvmResult) => {
            this.submitLoading = false
            console.log(pvmResult)
            if (pvmResult.result === 'true') {
              this.alertSuccess('试评开启成功')
            } else {
              this.alertError('试评开启失败')
            }
          }).finally(() => {
            this.submitLoading = false
          }).catch(err => {
            console.log(err)
            this.submitLoading = false
          })
      }
    },

    handleCancel () {
      this.$emit('dialog-close', {})
    },
    updateConfirmLabel () {
      let items = this.workItemStatus.slice() // 复制一份
      items[3] = 1 // 第四项不是必须项，故设为完成
      let arr = items.filter(val => val === 0)
      if (arr.length === 0) {
        this.confirmLabel = '去开启试评'
      }
    },
    alertError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },
    alertSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '确定',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
        }
      })
    },
    initData () {
      // todo: 查询考试科目是否是纯客观题，若是则返回主页面  getItemStructure
    // 查询考试科目的工作项状态（导入考生，收集题卡信息，设评卷方案，分评卷任务，扫描上传答题卡数量），更改confirmLabel,workItemStatus
      let param1 = {examId: this.examId, subjectName: this.subjectName}
      queryExamMonitor(param1).then(res => {
        let monitorItems = res.data.find(item => {
          return item.subjectId === this.subjectId
        }).monitorItems
        console.log(monitorItems)
        // [..., ["导入考生", 0, "未开始", [["数学", 0]], ...]
        function checkFinish (obj) {
          return obj.status && obj.status === '已完成' ? 1 : 0
        }
        // 不检测导入考生工作项，将改工作项设置为已完成
        monitorItems[2].status = '已完成'
        this.workItemStatus.push(checkFinish(monitorItems[2]), checkFinish(monitorItems[5]), checkFinish(monitorItems[6]), checkFinish(monitorItems[1]))
      }).then(() => {
        let param2 = {data: {examId: this.examId, subjectId: this.subjectId, orgId: this.userInfo.origanization}}
        queryScanProgressSummary(param2).then(res => {
          let status = res.data && res.data.upload.done > 0 ? 1 : 0
          this.workItemStatus.push(status)
          this.updateConfirmLabel()
        })
      }).catch(e => {
        console.log(e)
        this.alertError('网络异常，请稍后重试')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pre-pj-box{
  width: 820px;
  min-height: 300px;
  overflow: hidden;
  color: #606266;
  .title{
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    background: #469064;
    color: #fff;
    position: relative;
    i{
      position: absolute;
      right: 15px;
      top: 12px;
      font-size: 16px;
    }
  }
  .body{
    .tryout-body{
      width: 350px;
      margin: 0 auto 30px;
    }
  }
  .foot{
    margin: 10px auto;
    text-align: center;
    button{
      margin: 0 15px;
    }
  }
}
.check-item-table{
  width: 95%;
  margin: 10px auto;
  border-collapse: collapse;
  border: 1px solid #d8d8c9;
  td{
    border: 1px solid #d8d8c9;
  }

  .check-subject-header{
    padding: 20px 25px;
  }

  .subject-name{
    font-weight: bold;
    color: #000;
  }

  .check-item-row{
    td{
      border:none;
      border-top: 1px solid #d8d8c9;
      // padding: 36px 0 36px 54px;
      height: 65px;
      padding-left: 20px;
    }
    .check-label-wrapper{
      padding: 0;
      width: 100px;
      text-align: center;
      vertical-align: middle;
      border: 1px solid #d8d8c9;
    }
    .check-label{
      display: inline-block;
      width: 20px;
      line-height: 28px;
    }

  }

  .check-tip{
    display: inline-block;
    width: 460px;
  }

  .success-tip{
    color: #5eb388;
  }

  .check-pass{
    font-size: 19px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .check-fail{
    margin-right: 4px;
    font-size: 22px;
    vertical-align: middle;
    color: #ff0303;
  }

  .error-tip{
    color: #ff0000;
  }

  .fail-label{
    padding: 4px 6px;
    border: 1px solid #ff0303;
    border-radius: 4px;
    font-size: 12px;
  }

  .warn-tip{
    color: #ff8f17;
  }

  .check-warn{
    margin-right: 4px;
    font-size: 22px;
    vertical-align: middle;
    color: #ff8f17;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/open-pre-mark/OpenPreMark.vue